import React, {useState} from "react";
import PropTypes from "prop-types";
import {convertToEst} from "../../../Services/TimeZonesUtils";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import {AuditMediaNavModal} from "./AuditMediaNavModal";

export const AuditMediaThump = ({
    item,
    index,
    mediaObj,
    isImage = true,
    mediaFiles,
}) => {
    const [imageModalShow, setImageModalShow] = useState(null);
    const thumpWidth = "230px";
    const thumpHeight = "172.5px";

    function renderMediaThumpFooter(media) {
        return <div className="text-center" style={{fontSize: "10px"}}>
            {convertToEst(media.created_at, true)}
            <br />
            {`${media.notes || "-"}`}
        </div>;
    }

    function renderImageThump() {
        return <div key={`${index}`}>
            <button
                key={`${index}`}
                className="imgContainer border-0 bg-transparent mx-3 my-2 p-0"
                style={{width: thumpWidth}}
                onClick={() => setImageModalShow(
                    imageModalShow === mediaObj.image_value ? null : mediaObj.image_value,
                )}
            >
                {item &&
                    <div
                        className="text-center m-2"
                        style={{
                            fontSize: "10px",
                            height: "25px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}>
                        {item.audit_type_item.name}
                    </div>
                }
                <img
                    src={mediaObj.image_value}
                    className="img-fluid rounded-1"
                    alt="audit thumbnail"
                    style={{
                        width: thumpWidth,
                        height: thumpHeight,
                        objectFit: "contain",
                        backgroundColor: "#f8f9fa",
                    }}
                />
                {renderMediaThumpFooter(mediaObj)}
            </button>
        </div>;
    }

    function renderVideoThump() {
        return <div key={`${index}`}>
            <button
                className="imgContainer border-0 bg-transparent mx-3 my-2 p-0"
                style={{width: thumpWidth}}
                onClick={() => setImageModalShow(
                    imageModalShow === mediaObj.video_value ? null : mediaObj.video_value,
                )}
            >
                {item &&
                    <div
                        className="text-center m-2"
                        style={{
                            fontSize: "10px",
                            height: "25px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}>
                        {item.audit_type_item.name}
                    </div>
                }
                <div style={{position: "relative", width: "100%"}}>
                    <video
                        src={mediaObj.video_value}
                        className="img-fluid rounded-1"
                        playsInline={true}
                        muted={true}
                        preload="metadata"
                        onLoadedMetadata={(e) => {
                            e.target.currentTime = 0.1;
                        }}
                        style={{
                            display: "block",
                            width: "100%",
                            borderRadius: "6px",
                        }}
                    >
                    </video>
                    <PlayCircleFilledIcon
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "red",
                            fontSize: "2rem",
                            zIndex: 10,
                            pointerEvents: "none",
                        }}
                    />
                </div>
                {renderMediaThumpFooter(mediaObj)}
            </button>
        </div>;
    }

    return (<>
        {isImage ? renderImageThump() : renderVideoThump()}
        {imageModalShow && <AuditMediaNavModal
            key={`${item.id}_${index}`}
            item={item}
            mediaFiles={mediaFiles}
            isModalOpen={!!imageModalShow}
            onClose={() => setImageModalShow(null)}
            initialIndex={mediaFiles.findIndex((mediaFile) =>
                mediaFile.video_value === imageModalShow || mediaFile.image_value === imageModalShow)}
        />}
    </>);
};

AuditMediaThump.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        audit_type_item: PropTypes.shape({
            name: PropTypes.string.isRequired,
        }).isRequired,
    }),
    index: PropTypes.number.isRequired,
    mediaObj: PropTypes.shape({
        image_value: PropTypes.string,
        video_value: PropTypes.string,
        created_at: PropTypes.string.isRequired,
        notes: PropTypes.string,
    }).isRequired,
    isImage: PropTypes.bool,
    mediaFiles: PropTypes.arrayOf(PropTypes.object).isRequired,
};
